import styled from "styled-components";
import QRCodeBase, { QRCodeProps } from "qrcode.react";

export const StyledQRCode = styled(QRCodeBase)<QRCodeProps>`
  display: block;
  width: 100%;
  height: 100%;
`;
